module.exports = __webpack_public_path__ + "static/Portrait-of-Kasper-min-a39aa32a20547878bb873ff65838190f.jpg";